import { isLocalDevHost } from '../utils/tenantHost';

// Every deployed page (trimedcare.in, manoj.trimedcare.in, sri.trimedcare.in, ...)
// must call its own origin's /api — that's what lets CloudFront forward the real
// Host header to the backend for tenant resolution, and it needs no CORS setup.
// REACT_APP_API_BASE_URL is honored only on localhost / *.localhost, where the
// frontend and backend run as separate processes/containers on different ports
// (the backend then resolves the tenant from the X-Tenant-ID header).
export const API_BASE_URL = isLocalDevHost
  ? (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api')
  : '/api';
